export * from './providers/calendarEventTitle.provider';
export * from './providers/calendarMomentDateFormatter.provider';
export * from './providers/calendarNativeDateFormatter.provider';
export * from './providers/calendarDateFormatter.provider';
export * from './interfaces/calendarDateFormatter.interface';
export * from './calendar.module';
export {CalendarEvent, EventAction as CalendarEventAction} from 'calendar-utils';

// Private components, don't import or use these within your app, they are only exported so that AOT can work
export { CalendarDayViewComponent as PrivateComponent1 } from './components/day/calendarDayView.component';
export { CalendarWeekViewComponent as PrivateComponent2 } from './components/week/calendarWeekView.component';
export { CalendarMonthViewComponent as PrivateComponent3 } from './components/month/calendarMonthView.component';
export { CalendarEventActionsComponent as PrivateComponent4 } from './components/common/calendarEventActions.component';
export { CalendarEventTitleComponent as PrivateComponent5 } from './components/common/calendarEventTitle.component';
export { CalendarMonthCellComponent as PrivateComponent6 } from './components/month/calendarMonthCell.component';
export { CalendarOpenDayEventsComponent as PrivateComponent7 } from './components/month/calendarOpenDayEvents.component';
export { CalendarWeekViewHeaderComponent as PrivateComponent8 } from './components/week/calendarWeekViewHeader.component';
export { CalendarWeekViewEventComponent as PrivateComponent9 } from './components/week/calendarWeekViewEvent.component';
export { CalendarAllDayEventComponent as PrivateComponent10 } from './components/day/calendarAllDayEvent.component';
export { CalendarDayViewHourSegmentComponent as PrivateComponent11 } from './components/day/calendarDayViewHourSegment.component';
export { CalendarDayViewEventComponent as PrivateComponent12 } from './components/day/calendarDayViewEvent.component';
export { CalendarTooltipWindowComponent as PrivateComponent13 } from './directives/calendarTooltip.directive';
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
